/**
 * @generated SignedSource<<9193a5e6efebff6822efbe45ea11d436>>
 * @relayHash 2f41788a6aa62091a1680d76f9d65ce3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f63ce7d1b0e1a049ae33652cc8d18785d32f93cdf07885a8fd2272047a41c773

import type { ConcreteRequest, Query } from 'relay-runtime';
export type InsightsRecommendationVisibility = "HIDDEN" | "REMOVED" | "SNOOZED" | "VISIBLE" | "%future added value";
export type GithubOnboardingWrapperQuery$variables = {
  cloudId: string;
  projectAri?: string | null | undefined;
};
export type GithubOnboardingWrapperQuery$data = {
  readonly insights: {
    readonly githubOnboardingDetails: {
      readonly outboundAuthUrl: string;
      readonly recommendationVisibility: InsightsRecommendationVisibility;
    };
  } | null | undefined;
};
export type GithubOnboardingWrapperQuery = {
  response: GithubOnboardingWrapperQuery$data;
  variables: GithubOnboardingWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "concreteType": "Insights",
    "kind": "LinkedField",
    "name": "insights",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "projectAri"
          }
        ],
        "concreteType": "InsightsGithubOnboardingDetails",
        "kind": "LinkedField",
        "name": "githubOnboardingDetails",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "recommendationVisibility"
          },
          {
            "kind": "ScalarField",
            "name": "outboundAuthUrl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GithubOnboardingWrapperQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GithubOnboardingWrapperQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f63ce7d1b0e1a049ae33652cc8d18785d32f93cdf07885a8fd2272047a41c773",
    "metadata": {},
    "name": "GithubOnboardingWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "16ee246f010b9be0f5f9b2e7473e537c";

export default node;
